import { CoachDashboardLayout } from '../../components/CoachDashboard/CoachDashboardLayout';
import classes from './CoachDashboardPage.module.css';

export function CoachDashboardPage() {
  return (
    <div className={classes.page}>
      <CoachDashboardLayout />
    </div>
  );
}
